import { c as _c } from "react/compiler-runtime";
import { Heading as H, HeadingProps as HProps } from "common/components/Heading";
import clsx from "classnames";
export interface HeadingProps {
  text: string;
  level?: HProps["level"];
}
export const headingBlockLevelClassNames = (level: number, hasContent: boolean) => clsx({
  "mt-12 mb-4 first:mt-0 lg:first:mt-12": hasContent,
  "lg:mb-8": hasContent && level === 1
});
export const Heading = t0 => {
  "use memo";

  const $ = _c(11);
  const {
    text,
    level: t1
  } = t0;
  const level = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== text) {
    t2 = text?.trim();
    $[0] = text;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trimmedText = t2;
  const t3 = trimmedText.length > 0;
  let t4;
  if ($[2] !== level || $[3] !== t3) {
    t4 = headingBlockLevelClassNames(level, t3);
    $[2] = level;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== level || $[6] !== trimmedText) {
    t5 = <H level={level}>{trimmedText}</H>;
    $[5] = level;
    $[6] = trimmedText;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};